import { META } from './data';

// Stratos Footer — terminal-style "system" panel with mono uppercase only.
export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#06060A] text-[#EAF1F4] border-t border-[#EAF1F4]/10">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 py-12">
        {/* Operations terminal panel */}
        <div className="border border-[#EAF1F4]/10 bg-[#0F0F11] p-6 lg:p-8 grid md:grid-cols-3 gap-8 mb-12 font-mono text-[11px]">
          <div>
            <p className="text-[#D73B26] tracking-[0.3em] uppercase mb-3 text-[10px]">/ Air Ops Centre</p>
            <p className="text-[#EAF1F4]/85 leading-relaxed">Vienna International (LOWW)<br />Hangar 7, Operations Wing</p>
            <p className="text-[#EAF1F4]/55 mt-2">+43 1 7007 22 800</p>
          </div>
          <div>
            <p className="text-[#D73B26] tracking-[0.3em] uppercase mb-3 text-[10px]">/ Charter Desk</p>
            <p className="text-[#EAF1F4]/85 leading-relaxed">London — 24 / 7 / 365<br />Hong Kong — 06:00 — 22:00 HKT</p>
            <p className="text-[#EAF1F4]/55 mt-2">+44 20 7993 0140</p>
          </div>
          <div>
            <p className="text-[#D73B26] tracking-[0.3em] uppercase mb-3 text-[10px]">/ Certifications</p>
            <ul className="text-[#EAF1F4]/85 space-y-1 leading-relaxed">
              <li>EASA Part-CAT — AT.001.0114</li>
              <li>ARG/US Platinum — since 2017</li>
              <li>IS-BAO Stage III — current</li>
            </ul>
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-4 border-t border-[#EAF1F4]/10 pt-6 font-mono text-[10px] tracking-[0.25em] uppercase text-[#EAF1F4]/40">
          <span>© 2026 {META.brand} — {META.tail} · A Part-135 carrier</span>
          <div className="flex gap-6">
            <button onClick={() => setPage('safety')} className="hover:text-[#D73B26]">Safety File</button>
            <a href="#" className="hover:text-[#D73B26]">Wyvern</a>
            <a href="#" className="hover:text-[#D73B26]">Privacy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
